import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import { LOCAL__user_auth_set_open_page_after_login } from '@/state/user/auth/LOCAL__user_auth_set_open_page_after_login';
import { slice_user_initial_state } from '@/state/user/slice_user_initial_state';
import { useNavigate } from 'react-router-dom';

export function WATCHER__navigate_after_login() {
  const dispatch = use_dispatch();
  const navigate = useNavigate();

  const { is_authorized, open_page_after_auth } = use_slice_user(['is_authorized', 'open_page_after_auth']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (!is_authorized) return;

    void navigate(open_page_after_auth);

    dispatch(LOCAL__user_auth_set_open_page_after_login(slice_user_initial_state.open_page_after_auth));
  }, [is_authorized]);

  return <></>;
}
